import { c as _c } from "react/compiler-runtime";
import type { Icon } from '@onefootprint/icons';
import { useTranslation } from 'react-i18next';
export type InstructionItemsProps = {
  items: {
    title: string;
    description?: string;
    Icon: Icon;
  }[];
};
const InstructionItems = t0 => {
  const $ = _c(8);
  const {
    items
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "document-flow.components.photo-capture.instructions"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== items) {
    t3 = items.map(_temp2);
    $[3] = items;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <ul className="bg-primary rounded grid w-full gap-6 py-2" aria-label={t2}>{t3}</ul>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export default InstructionItems;
function _temp($) {
  return $.title;
}
function _temp2(t0) {
  const {
    title,
    description,
    Icon
  } = t0;
  return <li title={title} key={title} className="flex flex-row gap-2"><div className="relative -top-0.5"><Icon color="primary" /></div><div className="flex flex-col gap-2"><p className="text-label-2 text-primary fp-text">{title}</p>{description && <p className="text-body-2 text-secondary fp-text">{description}</p>}</div></li>;
}